import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

export type TicketStatus = "draft" | "pending" | "approved" | "rejected" | "clarification" | "archived";

const statusConfig: Record<TicketStatus, { labelKey: string; className: string }> = {
  draft: { labelKey: "statusChip.draft", className: "bg-status-draft-bg text-status-draft" },
  pending: { labelKey: "statusChip.pending", className: "bg-status-pending-bg text-status-pending" },
  approved: { labelKey: "statusChip.approved", className: "bg-status-approved-bg text-status-approved" },
  rejected: { labelKey: "statusChip.rejected", className: "bg-status-rejected-bg text-status-rejected" },
  clarification: { labelKey: "statusChip.clarification", className: "bg-status-signature-bg text-status-signature" },
  archived: { labelKey: "statusChip.archived", className: "bg-status-archived-bg text-status-archived" },
};

interface StatusChipProps {
  status: TicketStatus;
  className?: string;
  size?: "sm" | "default";
}

export function StatusChip({ status, className, size = "default" }: StatusChipProps) {
  const { t } = useTranslation();
  const config = statusConfig[status];
  return (
    <span className={cn(
      "inline-flex items-center rounded-full font-semibold whitespace-nowrap transition-colors",
      size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-0.5 text-xs",
      config.className,
      className
    )}>
      <span className={cn(
        "rounded-full mr-1.5 shrink-0",
        size === "sm" ? "h-1.5 w-1.5" : "h-2 w-2",
        status === "draft" && "bg-status-draft",
        status === "pending" && "bg-status-pending",
        status === "approved" && "bg-status-approved",
        status === "rejected" && "bg-status-rejected",
        status === "clarification" && "bg-status-signature",
        status === "archived" && "bg-status-archived",
      )} />
      {t(config.labelKey)}
    </span>
  );
}
